// SubmitUpdateForm.jsx
import React, { useState } from 'react';
import './submitupdatesmall.css';
import axiosInstance from '../axiosConfig';

const SubmitUpdateForm = ({ courseId, courseName, onClose }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [comments, setComments] = useState('');
  const [otherCategory, setOtherCategory] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const categories = ['Not Private Club', 'Initiation Fee', 'Annual Dues', 'Other'];

  const handleCategoryChange = (e) => {
    const { value, checked } = e.target;
    if (value === 'Other' && !checked) setOtherCategory('');
    setSelectedCategories(checked
      ? [...selectedCategories, value]
      : selectedCategories.filter(c => c !== value)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const data = {
      club_id: courseId,     // CHANGED: Send club_id instead of course_id
      course_id: null,       // ADDED: Explicitly set course_id to null
      categories: selectedCategories.includes('Other')
        ? [...selectedCategories.filter(c => c !== 'Other'), otherCategory]
        : selectedCategories,
      comment: comments,
    };

    console.log('Submitting update with data:', data); // DEBUG: Log the payload

    try {
      const response = await axiosInstance.post('/submit_update_view/', data);
      console.log('Submission successful:', response.data);
      alert('Update submitted successfully!');
      onClose();
    } catch (err) {
      console.error('Error submitting update:', err.response?.data || err.message);
      alert('Failed to submit the update. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="submit-update-form overlay">
      <div className="form-container-submit-update">
        <h2>Submit Update</h2>
        {courseName && <p className="course-name3">Updating: {courseName}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group2">
            <label>Select Categories:</label>
            <div className="checkbox-group">
              {categories.map(cat => (
                <label key={cat} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={cat}
                    checked={selectedCategories.includes(cat)}
                    onChange={handleCategoryChange}
                  />
                  {cat}
                </label>
              ))}
            </div>
            {selectedCategories.includes('Other') && (
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Specify other category"
                  value={otherCategory}
                  onChange={e => setOtherCategory(e.target.value)}
                  className="other-category-input"
                />
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Comments:</label>
            <textarea
              placeholder="Describe the issue or update..."
              value={comments}
              onChange={e => setComments(e.target.value)}
              className="comments-box"
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
            <button type="button" className="cancel-button" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubmitUpdateForm;